import axios from 'axios'
import Vue from 'vue'
import * as Sentry from '@sentry/vue'
import defaultProductConfig from '~/plugins/add-product-defaults.js'

// eslint-disable-next-line import/no-mutable-exports
const configSettings = {
	siteName: 'Stan',
	env_name: process.env.ENV_NAME,
	pythonApiUrl: process.env.VUE_APP_API_PYTHON_BASE_URL,
	authApiUrl: process.env.VUE_APP_API_AUTH_BASE_URL,
	informalApiUrl: process.env.VUE_APP_INFORMAL_API_BASE_URL,
	noHttpsDomain: process.env.FRONT_DOMAIN_NO_PROTOCOL,
	frontDomain: `https://${process.env.FRONT_DOMAIN_NO_PROTOCOL}`,
	noHttpsLandingDomain: process.env.LANDING_DOMAIN_NO_PROTOCOL,
	landingDomain: `https://${process.env.LANDING_DOMAIN_NO_PROTOCOL}`,
	stripeKey: process.env.VUE_APP_STRIPE_KEY,
	stripePlatformKey: process.env.VUE_APP_PLATFORM_STRIPE_KEY,

	analyticsApi: process.env.VUE_APP_ANALYTICS_API,
	zapierInviteLink: 'https://zapier.com/apps/stan-creator/integrations',
	sentryDsn: process.env.VUE_APP_SENTRY_DSN,
	mouseflowAnalyticsTrackingCode: process.env.MOUSEFLOW_ANALYTICS_TRACKING_CODE || null,
	unsplashApiClientId: process.env.VUE_APP_UNSPLASH_API_CLIENT_ID || null,
	nicheRecommendationPages: defaultProductConfig,
	releaseVersion: process.env.ENV_RELEASE_VERSION,
	assetsDomain: process.env.VUE_APP_IMAGE_ASSETS,
	chatAIApiUrl: process.env.CHAT_AI_API_BASE_URL,
	chatAIApiUrlV2: process.env.CHAT_AI_API_V2_BASE_URL,
	chatAICoachApiUrl: process.env.CHAT_AI_COACH_API_BASE_URL,
	clarityTrackingCode: process.env.VUE_APP_CLARITY_TRACKING_CODE,
	captchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY,
	communityDomain: process.env.COMMUNITY_DOMAIN,
	communityApiUrl: process.env.VUE_APP_COMMUNITY_API_BASE_URL,

	instagramClientId: process.env.VUE_APP_INSTAGRAM_CLIENT_ID,
	instagramRedirectUri: process.env.VUE_APP_INSTAGRAM_REDIRECT_URI,
	v2AppUrl: process.env.VUE_APP_V2_APP_URL,
	appDomainNoProtocol: process.env.VUE_APP_DOMAIN_NO_PROTOCOL,
}

axios.defaults.baseURL = configSettings.pythonApiUrl
if (configSettings.env_name === 'staging' || configSettings.env_name === 'production') {
	Sentry.init({
		Vue,
		environment: configSettings.env_name,
		dsn: configSettings.sentryDsn,
		tracesSampleRate: 0,
		release: configSettings.releaseVersion,
		integrations: [],
		beforeSend(event, hint) {
			let ignoreEvent = false
			if (event.exception?.values.length > 0) {
				event.exception?.values.forEach(ex => {
					if (ex.value.indexOf('ResizeObserver') > -1) ignoreEvent = true
					else if (ex.type === 'NavigationDuplicated') {
						ignoreEvent = true
					} else if (ex.type === 'Event') {
						// eslint-disable-next-line no-console
						console.log('Ignoring Event', ex.type, ex.value)
						ignoreEvent = true
					} else if (ex.type === 'TypeError') {
						if (ex.value.indexOf('naturalWidth') > -1) ignoreEvent = true
						if (
							ex.value === "Cannot read properties of null (reading 'classList')" ||
							ex.value === "null is not an object (evaluating 't.target.parentNode.classList'"
						)
							ignoreEvent = true
						// eslint-disable-next-line no-console
						if (ignoreEvent) console.log('Ignoring Error', ex.type, ex.value)
					} else if (ex.type === 'SyntaxError') {
						if (ex.value.indexOf('Unexpected token') > -1) ignoreEvent = true
					} else if (ex.type === 'Error') {
						const httpCode4xxIndex = ex.value.search(/\s4[0-9]{2,2}$/)
						const errorRequestFailedIndex = ex.value.toLowerCase().search('request failed with status code')
						if (ex.value === 'Network Error') ignoreEvent = true
						else if (errorRequestFailedIndex > -1 && httpCode4xxIndex > -1) {
							ignoreEvent = true
						} else if (ex.value === 'undefined') {
							ignoreEvent = true
						} else if (ex.value.indexOf('Navigation cancelled from') !== -1) {
							ignoreEvent = true
						} else if (ex.value.indexOf('Redirected when going from') !== -1) {
							ignoreEvent = true
						}
						if (ignoreEvent) {
							// eslint-disable-next-line no-console
							console.log('Ignoring Error', ex.type, ex.value)
						}
					} else if (hint.originalException === 'Timeout') {
						ignoreEvent = true
					}
				})
			}
			if (ignoreEvent) return null

			return event
		},
	})
}

// eslint-disable-next-line import/prefer-default-export
export { configSettings }
